module.exports = __webpack_public_path__ + "static/media/zoom_map_minus.e103d1f7.svg";